<template>
  <div
    class="dash_icon"
    :style="{ backgroundImage: `url(${currentBackground})` }"
  ></div>
</template>
<script>
export default {
  props: {
    isActive: { type: Boolean, default: false },
    defaultIcon: { type: String, default: "ic_houwudeng.png" },
    activeIcon: { type: String, default: "ic_houwudeng_active.png" },
  },
  data() {
    return {};
  },
  computed: {
    currentBackground() {
      return require(`@/assets/images/${
        this.isActive ? this.activeIcon : this.defaultIcon
      }`);
    },
  },
  methods: {},
};
</script>
<style scoped>
.dash_icon {
  display: inline-block;
  width: 40px;
  height: 40px;
  background-size: cover;
  float: left;
  margin-right: 20px;
}
</style>
